export default "__VITE_PUBLIC_ASSET__8e4240ca__"